







import { Vue, Prop, Component } from 'vue-property-decorator';

import Tooltip from '~/patterns/atoms/tooltip.vue';

@Component({
    components: { Tooltip },
    data: () => {
        return {
            showTooltip: false
        };
    },
    methods: {
        openTooltip() {
            this.$data.showTooltip = true;
        },
        closeTooltip() {
            this.$data.showTooltip = false;
        }
    }
})
export default class SolutionIcon extends Vue {
    @Prop() readonly icon!: string;
    @Prop() readonly altText: string;

    getIconPath(): string {
        return require(`~/assets/images/icons/${this.icon}.svg`);
    }
}
